import AdvertCard from 'components/common/advert-card';
import AdvertWrapper from 'layout/advert-wrapper';
import React, { useEffect, useState } from 'react';
import { IOption, PROPERTY_TYPE } from 'types';

import Filters from '../../../../components/common/filters';
import {
    DarxApplicationDtOsAdsDtOsAdsGetAllDto,
    useGetApiV1ClientAdsQuery,
} from 'service/api/allApis';
import InfiniteScroll from 'react-infinite-scroll-component';
import { RenderIf } from 'components/common/render-if';
import { Spinner } from 'components/common/spinner';
import { DEFAULT_PAGINATION_DATA } from 'lib/constants';
import { useTranslation } from 'react-i18next';

const AllAdverts = () => {
    const { t } = useTranslation();
    const [filterPropertyType, setFilterPropertyType] = useState({
        value: '',
        label: t('general.all-adverts'),
    });
    const [pagination, setPagination] = useState(DEFAULT_PAGINATION_DATA);
    const [items, setItems] = useState<DarxApplicationDtOsAdsDtOsAdsGetAllDto[]>([]);
    const { data, isLoading, status } = useGetApiV1ClientAdsQuery(
        {
            ...pagination,
            ...(filterPropertyType.value
                ? { propertyType: filterPropertyType.value as PROPERTY_TYPE }
                : {}),
        },
        {
            refetchOnMountOrArgChange: true,
        },
    );

    function getNextPage() {
        setPagination({ ...pagination, pageNumber: pagination.pageNumber + 1 });
    }

    const hasMore = !!(
        data &&
        data.totalPages &&
        data.pageNumber &&
        data?.totalPages > data?.pageNumber
    );

    const filterOptions = [
        {
            value: '',
            label: t('general.all-adverts'),
        },
        {
            value: String(PROPERTY_TYPE.NEW_BUILDING),
            label: t('advert.new-building'),
        },
        {
            value: String(PROPERTY_TYPE.OLD_BUILDING),
            label: t('advert.old-building'),
        },
        {
            value: String(PROPERTY_TYPE.COMMERCIAL),
            label: t('advert.commercial'),
        },
        {
            value: String(PROPERTY_TYPE.OFFICE),
            label: t('advert.office'),
        },
        {
            value: String(PROPERTY_TYPE.GARAGE),
            label: t('advert.garage'),
        },
        {
            value: String(PROPERTY_TYPE.YARD_HOUSE),
            label: t('advert.yard-house'),
        },
        {
            value: String(PROPERTY_TYPE.LAND),
            label: t('advert.land'),
        },
    ];

    const handlePropertyFilterChange = (option: IOption) => {
        setFilterPropertyType(option);
        setPagination(DEFAULT_PAGINATION_DATA);
    };

    useEffect(() => {
        if (status === 'fulfilled' && data) {
            const items = data?.items ?? [];
            setItems((prev) => (pagination.pageNumber > 1 ? [...prev, ...items] : items));
        }
    }, [status]);

    return (
        <div className=" w-full px-5 md:px-0 md:w-[925px] lg:w-[1240px] mx-auto z-[1] relative">
            <h2 className="text-brend text-center text-[32px] leading-[44px] font-bold tracking-[3.84px]">
                {t('general.all-adverts')}
            </h2>
            <Filters
                options={filterOptions}
                selectedOption={filterPropertyType}
                onOptionChange={handlePropertyFilterChange}
            />
            {/* <Navigation /> */}
            <InfiniteScroll
                dataLength={items.length}
                next={getNextPage}
                hasMore={hasMore}
                loader={<Spinner size={40} color="rgb(177,146,76)" className="mt-6 mx-auto" />}
            >
                <AdvertWrapper>
                    <RenderIf condition={isLoading}>
                        {[...Array(9)].map((_, index) => (
                            <AdvertCard.Skeleton key={index} />
                        ))}
                    </RenderIf>
                    <RenderIf condition={!isLoading}>
                        {items.map((advert) => (
                            <AdvertCard key={advert.id} advert={advert} />
                        ))}
                    </RenderIf>
                </AdvertWrapper>
            </InfiniteScroll>
        </div>
    );
};

export default AllAdverts;
